import React from "react";
// import MockedFooter from "../../v2components/element/MockedFooter/MockedFooter";
import MockedFooter from "../../v2components/element/Footer/Footer";

export default MockedFooter;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js